import { render } from "./postcard.vue?vue&type=template&id=d79b9e94&scoped=true"
import script from "./postcard.vue?vue&type=script&lang=js"
export * from "./postcard.vue?vue&type=script&lang=js"

import "./postcard.vue?vue&type=style&index=0&id=d79b9e94&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d79b9e94"]])

export default __exports__